import React from "react";
import "./section14.css"

const Section14 = () => {
  return (
    <section id="" className="imageblock-section switchable switchable-content">
      <div className="row" style={{ marginRight: "0px", marginLeft: "0px" }}>
        <div
          className="col-lg-12 col-md-12"
          style={{ paddingRight: "0px", paddingLeft: "0px" }}
        >
          <div
            className="background-image-holder inline_sec14_style1"
            id="phamapay"
          ></div>
        </div>
      </div>
    </section>
  );
};

export default Section14;
